const styles = {
  container: {
    display: "none",
  },

  "@media screen and (max-width : 1199px)": {
    container: {
      border: 0,
      width: "40px",
      height: "40px",
      cursor: "pointer",
      padding: "3px 0 0 0",
      display: "flex",
      boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
      alignItems: "center",
      borderRadius: "50%",
      justifyContent: "center",
      backgroundColor: "#FFFFFF",
      zIndex: "800",
    },
  },
};

export default styles;
